/* eslint-disable angular/controller-as */
angular.
module("digiexam").
controller("DxViewGradingMatrixController", function ViewGradingMatrixController(
	$scope,
	dxDialog
) {
	"use strict";
	$scope.close = dxDialog.closeMostRecent;
});
